export default function randomBase64(length = 16, penultimate = '-', ultimate = '_')
{
	penultimate = penultimate.charCodeAt(0);
	ultimate = ultimate.charCodeAt(0);

	return String.fromCharCode.apply
	(
		0,
		Array.from
		(
			Array(length),
			() =>
			{
				const v = Math.random()*64 | 0;
				return v < 10 ? v+48 :
					v < 36 ? v+55 :
					v < 62 ? v+61 :
					v === 62 ? penultimate :
					ultimate;
			}
		)
	)
}
